import { createAction } from '@reduxjs/toolkit';
import { ScorecardsActionStoreArgument } from 'store/interfaces';

export const changePage = createAction<{
  store: ScorecardsActionStoreArgument;
  page: number;
}>('scorecards/changePage');
